import { dataBulbDash } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBulbDash = /*#__PURE__*/createIcon(dataBulbDash)
export default IconBulbDash
